export enum BannerRedirectType {
  PACKS = "PACKS",
  PRESETS = "PRESETS",
  CREATORS = "CREATORS",
  LIST_OF_PACKS = "LIST_OF_PACKS",
  LIST_OF_PRESETS = "LIST_OF_PRESETS",
  SUBSCRIPTION = "SUBSCRIPTION",
  TEMPLATES_GALLERY = "TEMPLATES_GALLERY",
}

// Tipos que exigem uma collection (redirectId) associada
export const REDIRECT_TYPES_REQUIRING_COLLECTION: BannerRedirectType[] = [
  BannerRedirectType.PACKS,
  BannerRedirectType.PRESETS,
  BannerRedirectType.CREATORS,
  BannerRedirectType.LIST_OF_PACKS,
  BannerRedirectType.LIST_OF_PRESETS,
];

// Resposta administrativa da API (GET /admin/banners e /:id)
export interface Banner {
  id: string;
  description: string;
  url: string;
  published: boolean;
  displayOrder: number;
  redirectType: BannerRedirectType | null;
  redirectId: string | null;
  isActive: boolean;
  startDate: string | null;
  endDate: string | null;
  minBuildAndroid: number | null;
  minBuildIos: number | null;
  createdAt: string;
  lastUpdatedAt: string | null;
  createdById: string;
}

// Dados enviados no campo `data` (JSON) do multipart
export interface BannerData {
  description: string;
  redirectType: BannerRedirectType;
  redirectId?: string | null;
  displayOrder?: number;
  isActive?: boolean;
  published?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  minBuildAndroid?: number | null;
  minBuildIos?: number | null;
}

export interface CreateBannerPayload {
  data: BannerData;
  image: File;
}

export interface UpdateBannerPayload {
  data: Partial<BannerData>;
  image?: File;
}
